export default from './load-more';



// WEBPACK FOOTER //
// ./app/components/load-more/index.js